/* Veloura theme — cart drawer (Ajax API + Section Rendering), variant picker, modals. */
(function () {
  'use strict';
  var V = window.Veloura || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function ls(k, v) { try { return v === undefined ? localStorage.getItem(k) : localStorage.setItem(k, v); } catch (e) { return null; } }

  /* ───────── overlays ───────── */
  var scrim = $('#scrim'), mmenu = $('#mmenu');
  function drawer() { return $('#drawer'); }
  function anyOpen() { return (drawer() && drawer().classList.contains('on')) || (mmenu && mmenu.classList.contains('on')) || $$('.modal.on').length; }
  function openCart() { var d = drawer(); if (d) { d.classList.add('on'); scrim.classList.add('on'); } }
  function openModal(id) { var m = document.getElementById(id); if (m) { m.classList.add('on'); scrim.classList.add('on'); } }
  function closeAll() {
    var wasWelcome = $('#welcomeModal') && $('#welcomeModal').classList.contains('on');
    var d = drawer(); if (d) d.classList.remove('on');
    if (mmenu) mmenu.classList.remove('on');
    $$('.modal').forEach(function (m) { m.classList.remove('on'); });
    scrim.classList.remove('on');
    if (wasWelcome) setTimeout(showTeaser, 380);
  }
  var toastEl = $('#toast'), toastT;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg; toastEl.classList.add('on');
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('on'); }, 2400);
  }

  /* ───────── cart (Ajax API + section rendering) ───────── */
  function money(cents) {
    var f = V.moneyFormat || '${{amount}}';
    var amt = (cents / 100).toFixed(2);
    return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amt);
  }
  function swapDrawer(sectionsJson) {
    var html = sectionsJson && sectionsJson['cart-drawer'];
    if (!html) return refreshDrawer();
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var fresh = tmp.querySelector('#drawer'), cur = drawer();
    if (fresh && cur) {
      var wasOpen = cur.classList.contains('on');
      cur.replaceWith(fresh);
      if (wasOpen) fresh.classList.add('on');
      var n = $('#cartN'); if (n) n.textContent = '(' + (fresh.getAttribute('data-count') || '0') + ')';
    }
    return Promise.resolve();
  }
  function refreshDrawer() {
    return fetch(V.routes.root + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); }).then(swapDrawer);
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || 'Could not update bag'); e.data = j; throw e; } return j; });
    });
  }
  function addVariant(id, qty) {
    var d = drawer(); if (d) d.classList.add('is-loading');
    return post(V.routes.cartAdd, { items: [{ id: Number(id), quantity: qty || 1 }], sections: 'cart-drawer' })
      .then(function (j) { return swapDrawer(j.sections); })
      .then(function () { openCart(); })
      .finally(function () { var d2 = drawer(); if (d2) d2.classList.remove('is-loading'); });
  }
  function changeLine(key, qty) {
    var d = drawer(); if (d) d.classList.add('is-loading');
    return post(V.routes.cartChange, { id: key, quantity: qty, sections: 'cart-drawer' })
      .then(function (j) { return swapDrawer(j.sections); })
      .catch(function (e) { toast(e.message); })
      .finally(function () { var d2 = drawer(); if (d2) d2.classList.remove('is-loading'); });
  }

  /* ───────── product page ───────── */
  var pj = $('#productJson'), product = null;
  try { product = pj ? JSON.parse(pj.textContent) : null; } catch (e) { product = null; }

  function selectedOptions() {
    if (!product) return [];
    var cur = currentVariant();
    return product.options.map(function (name, i) {
      var b = $('[data-opt="' + i + '"][aria-pressed="true"]');
      return b ? b.getAttribute('data-value') : (cur ? cur.options[i] : null);
    });
  }
  function currentVariant() {
    if (!product) return null;
    var id = Number(($('#variantId') || {}).value);
    return product.variants.filter(function (v) { return v.id === id; })[0] || product.variants[0];
  }
  function findVariant(opts) {
    return product.variants.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0] || null;
  }
  function fitLineFor(letter, type) {
    var s = (V.sizes || {})[letter]; if (!s) return '';
    if (type === 'bra' || type === 'top' || type === 'longsleeve') return 'Fits bust <b>' + s.bust + '</b>';
    if (type === 'short' || type === 'legging') return 'Fits waist <b>' + s.waist + '</b> · hip <b>' + s.hip + '</b>';
    return 'Fits bust <b>' + s.bust + '</b> · waist <b>' + s.waist + '</b> · hip <b>' + s.hip + '</b>';
  }
  function syncProduct() {
    if (!product) return;
    var opts = selectedOptions(), v = findVariant(opts), atc = $('#atc');
    // availability of each size/option value given the other selections
    $$('[data-opt]').forEach(function (b) {
      var i = Number(b.getAttribute('data-opt')), test = opts.slice(); test[i] = b.getAttribute('data-value');
      var tv = findVariant(test);
      var unavailable = !tv || !tv.available;
      if (b.classList.contains('size') || b.classList.contains('opt-btn')) b.classList.toggle('is-unavailable', unavailable);
    });
    if (v) {
      $('#variantId').value = v.id;
      var price = $('#pdpPrice'); if (price) price.textContent = money(v.price);
      if (atc) { atc.disabled = !v.available; atc.textContent = v.available ? ('Add to bag — ' + money(v.price)) : 'Sold out'; }
      if (window.history && history.replaceState) {
        var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
      }
      var img = $('#pdpMainImg');
      if (img && v.featured_image && v.featured_image.src) img.src = v.featured_image.src;
    } else if (atc) { atc.disabled = true; atc.textContent = 'Unavailable'; }
    // placeholder art follows the colour
    var colorIdx = product.options.map(function (o) { return o.toLowerCase(); }).indexOf('color');
    if (colorIdx < 0) colorIdx = product.options.map(function (o) { return o.toLowerCase(); }).indexOf('colour');
    if (colorIdx >= 0) {
      var col = opts[colorIdx];
      $$('[data-art-color]').forEach(function (a) { a.hidden = a.getAttribute('data-art-color') !== col; });
      var cn = $('#colorName'); if (cn && col) cn.textContent = String(col).toLowerCase().replace(/(^|\s)\S/g, function (m) { return m.toUpperCase(); });
    }
    var fl = $('#fitLine');
    if (fl) {
      var sizeIdx = product.options.map(function (o) { return o.toLowerCase(); }).indexOf('size');
      fl.innerHTML = sizeIdx >= 0 ? fitLineFor(opts[sizeIdx], fl.getAttribute('data-type')) : '';
    }
  }

  /* ───────── delegated events ───────── */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('#openCart')) { e.preventDefault(); refreshDrawer().then(openCart); return; }
    if (t.closest('#closeCart') || t.closest('[data-close-cart]') || t.closest('[data-close-modal]')) { closeAll(); return; }
    if (t.closest('#burger')) { mmenu.classList.add('on'); scrim.classList.add('on'); return; }
    if (t.closest('#closeMenu')) { closeAll(); return; }
    if (t.closest('#openSearch')) { openModal('searchModal'); setTimeout(function () { var i = $('#searchInput'); if (i) i.focus(); }, 60); return; }
    if (t.closest('#openSize')) { openModal('sizeModal'); return; }
    if (t.closest('#teaserOpen')) { hideTeaser(); openModal('welcomeModal'); return; }
    if (t.closest('#teaserX')) { hideTeaser(); ls('veloura-teaser-off', '1'); return; }

    var q = t.closest('[data-line-key]');
    if (q) { changeLine(q.getAttribute('data-line-key'), Number(q.getAttribute('data-qty'))); return; }
    var qa = t.closest('[data-quick-add]');
    if (qa) { addVariant(qa.getAttribute('data-quick-add'), 1).catch(function (err) { toast(err.message); }); return; }

    var opt = t.closest('[data-opt]');
    if (opt) {
      var i = opt.getAttribute('data-opt');
      $$('[data-opt="' + i + '"]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === opt)); });
      syncProduct(); return;
    }
    var th = t.closest('.pdp-thumb[data-img]');
    if (th) {
      var img = $('#pdpMainImg'); if (img) img.src = th.getAttribute('data-img');
      $$('.pdp-thumb').forEach(function (x) { x.setAttribute('aria-pressed', String(x === th)); });
      return;
    }
    var acc = t.closest('.acc-h');
    if (acc) {
      var body = acc.nextElementSibling, open = !body.hidden;
      body.hidden = open; acc.setAttribute('aria-expanded', String(!open));
      var s = acc.querySelector('span'); if (s) s.textContent = open ? '+' : '−';
      return;
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.id !== 'protectChk') return;
    var box = e.target, vid = box.getAttribute('data-protect-vid'), key = box.getAttribute('data-protect-key');
    var p = box.checked ? addVariant(vid, 1) : changeLine(key, 0);
    Promise.resolve(p).then(function () { toast(box.checked ? 'Shipping protection added' : 'Shipping protection removed'); })
      .catch(function (err) { toast(err.message); });
  });

  document.addEventListener('submit', function (e) {
    var f = e.target;
    // NB: a form containing <input name="id"> shadows form.id — read the attribute instead
    if (!f.getAttribute || f.getAttribute('id') !== 'product-form') return;
    e.preventDefault();
    var atc = $('#atc'), err = $('#atcErr');
    if (err) err.hidden = true;
    if (atc) atc.classList.add('is-loading');
    addVariant($('#variantId').value, 1)
      .then(function () { toast('Added to bag'); })
      .catch(function (x) { if (err) { err.textContent = x.message; err.hidden = false; } })
      .finally(function () { if (atc) atc.classList.remove('is-loading'); });
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && anyOpen()) closeAll(); });
  if (scrim) scrim.addEventListener('click', closeAll);

  /* ───────── predictive search ───────── */
  var sTimer;
  document.addEventListener('input', function (e) {
    if (e.target.id !== 'searchInput') return;
    var q = e.target.value.trim(), box = $('#searchResults');
    clearTimeout(sTimer);
    if (!q) { box.innerHTML = ''; return; }
    sTimer = setTimeout(function () {
      fetch(V.routes.predictive + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var ps = ((j.resources || {}).results || {}).products || [];
          ps = ps.filter(function (p) { return p.handle !== 'shipping-protection'; });
          box.innerHTML = ps.length ? ps.map(function (p) {
            return '<a class="cross" style="margin-top:10px" href="' + p.url + '"><div class="cross-t"><p class="n">' +
              p.title.replace(/</g, '&lt;') + '</p><p class="p">' + (p.price ? money(Math.round(parseFloat(p.price) * 100)) : '') + '</p></div></a>';
          }).join('') : '<p class="note">Nothing matched — try “set”, “short” or “bra”.</p>';
        }).catch(function () { box.innerHTML = ''; });
    }, 180);
  });

  /* ───────── announcement rotator ───────── */
  var barTrack = $('#barTrack');
  if (barTrack && barTrack.children.length > 1) {
    var barI = 0, n = barTrack.children.length;
    var step = function () { return barTrack.children[0].offsetHeight || 38; };
    setInterval(function () { barI = (barI + 1) % n; barTrack.style.transform = 'translateY(-' + (barI * step()) + 'px)'; }, 4200);
    window.addEventListener('resize', function () { barTrack.style.transform = 'translateY(-' + (barI * step()) + 'px)'; });
  }

  /* ───────── welcome offer ───────── */
  var teaser = $('#teaser');
  function showTeaser() { if (teaser && ls('veloura-teaser-off') !== '1' && ls('veloura-joined') !== '1') teaser.classList.add('on'); }
  function hideTeaser() { if (teaser) teaser.classList.remove('on'); }
  var posted = /[?&]customer_posted=true/.test(location.search) || /#.*(welcomeForm|footSub)/.test(location.hash);
  if (posted) {
    ls('veloura-joined', '1'); hideTeaser();
    if ($('#welcomeOk')) openModal('welcomeModal');
  } else if (V.welcomeEnabled && $('#welcomeModal')) {
    setTimeout(function () {
      var count = Number((drawer() || {}).getAttribute ? drawer().getAttribute('data-count') : 0) || 0;
      if (ls('veloura-welcome') !== '1' && ls('veloura-joined') !== '1' && !count && !anyOpen()) { openModal('welcomeModal'); ls('veloura-welcome', '1'); }
      else showTeaser();
    }, V.welcomeDelay || 6000);
  }

  syncProduct();
})();
